/**
 * CMS locale constants (match Prismic locales).
 * UI codes (en, es, fr...) map to these values via `UI_TO_CMS_MAP`.
 */

export const LOCALES = {
    // CMS/Prismic locale codes
    ENGLISH: 'en-au',
    SPANISH: 'es-es',
    FRENCH: 'fr-fr',
    GERMAN: 'de-de',
    PORTUGUESE_BRAZILIAN: 'pt-br',
    CHINESE_SIMPLIFIED: 'zh-cn',
    RUSSIAN: 'ru-ru',
    POLISH: 'pl-pl',
    JAPANESE: 'ja-jp',
    DUTCH: 'nl-nl',
    ITALIAN: 'it-it',
    KOREAN: 'ko-kr',
} as const;

// Map the shorter UI locale codes used in settings to the exact CMS locale
// strings required by Prismic. Keep this mapping explicit so it's obvious how
// UI choices translate into CMS queries.
export const UI_TO_CMS_MAP = {
    en: LOCALES.ENGLISH,
    es: LOCALES.SPANISH,
    fr: LOCALES.FRENCH,
    de: LOCALES.GERMAN,
    pt: LOCALES.PORTUGUESE_BRAZILIAN,
    zh: LOCALES.CHINESE_SIMPLIFIED,
    ru: LOCALES.RUSSIAN,
    pl: LOCALES.POLISH,
    ja: LOCALES.JAPANESE,
    nl: LOCALES.DUTCH,
    it: LOCALES.ITALIAN,
    ko: LOCALES.KOREAN,
} as const;

export const DEFAULT_LOCALE = LOCALES.ENGLISH;
export const DEFAULT_LOCALE_LANGUAGE_CODE = 'en';
export const SUPPORTED_LOCALES = Object.values(LOCALES);

export type SupportedLocale = (typeof LOCALES)[keyof typeof LOCALES];
